import { useFadeIn } from "../../hooks/useFadeIn";
import { SectionHeader } from "../layout/SectionHeader";

const COLUMNS: { label: string; key: string; items: string[] }[] = [
  { label: "[frontend]", key: "frontend", items: ["React", "TypeScript", "Next.js", "Redux", "Tailwind", "AG Grid", "Storybook", "Cypress"] },
  { label: "[backend]",  key: "backend",  items: ["Node.js", "Express", "REST APIs", "MongoDB", "MySQL", "Python"] },
  { label: "[tooling]",  key: "tooling",  items: ["Git", "CI/CD", "Figma", "Vercel", "DevTools"] },
];

export const Stack = () => {
  const ref = useFadeIn<HTMLElement>();
  return (
    <section ref={ref} className="stack reveal" id="stack">
      <div className="container">
        <SectionHeader num="02" command="> stack.json" caption="What I reach for first." />
        <div className="stack__grid">
          {COLUMNS.map((col) => (
            <article className="stackCard" key={col.key}>
              <h3 className="stackCard__label">{col.label}</h3>
              <ul>
                {col.items.map((it) => (
                  <li key={it}><span className="stackCard__chev">&gt;</span> {it.toUpperCase()}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
